module.exports = __webpack_public_path__ + "static/media/icon_down.340702a5.svg";